import { FC, useMemo } from 'react'

import { ClockIcon } from 'assets/icons/clock-icon'

import { oppositePlayer } from 'features/board/utils'
import { Player } from 'features/firebase/types'

import { RelativePlayerPosition, useGameContext } from '../game-context'
import { formatRemainingTime, isGameOpen } from '../utils'

interface TimerProps {
  position: RelativePlayerPosition
  playerInfo: Player | null
}

export const Timer: FC<TimerProps> = ({ position, playerInfo }) => {
  const {
    game: { status, result },
    turn,
    turnDuration,
    relativeGameData: { playerColor, clock },
  } = useGameContext()

  const isActive = isGameOpen(status) && turn === playerColor[position]

  const displayTime = useMemo(() => {
    let res = clock[position]

    if (isActive) {
      res -= turnDuration
    } else if (
      status === 'finished' &&
      result?.reason === 'timeout' &&
      result?.winner === oppositePlayer(playerColor[position])
    ) {
      res = 0
    }

    return formatRemainingTime(Math.max(res, 0))
  }, [clock, isActive, playerColor, position, result, status, turnDuration])

  return (
    <div
      data-active={isActive}
      className="flex items-center gap-1 rounded-xl bg-white px-3 py-2 text-red-500 data-[active=false]:bg-black data-[active=false]:text-white data-[active=false]:opacity-70 sm:gap-5 sm:px-5 lg:rounded-2xl lg:py-3"
    >
      <ClockIcon className="h-5 lg:h-8" />
      {status === 'playing' && playerInfo && !playerInfo.online ? (
        <span className="font-bold lg:text-2xl">Reconnecting...</span>
      ) : (
        <span className="font-bold lg:text-2xl">{displayTime}</span>
      )}
    </div>
  )
}
